const isProduction = process.env.NODE_ENV === "production";

export const SERVER_URL = isProduction
  ? "https://back-end-production-07e5.up.railway.app/api"
  : "http://localhost:5000/api";

export const IMG_SERVER_URL = isProduction
  ? "https://back-end-production-07e5.up.railway.app"
  : "http://localhost:5000";
